import { app } from '../../../../../app';
import { Controller } from './blocked-users.controller';

app.component('companyUserDirectoriesSaaspassUsersBlockedUsers', {
    bindings: {
        blockedUsers: '<',
        companyId: '<',
        labels: '<',
        numberOfUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./blocked-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/blocked-users/blocked-users.component.js